import RelationshipDashboardRedirect from "./RelationshipDashboardRedirect";

export default RelationshipDashboardRedirect;
export { RelationshipDashboardRedirect };
